var Vendd = (function (Vendd) {
    'use strict';

    Vendd.CustomForms = (function (CustomForms) {

        CustomForms.Messages = (function (Messages) {

  
            Messages.SendNotification = function (data) {
         
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.CustomForms.Messages.SendNotification', data);
        };
            Messages.SendNotification.className = 'Vendd.CustomForms.Messages.SendNotification';


            Messages.SendNotificationSuccess = function (response) {
              
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.CustomForms.Messages.SendNotificationSuccess', response);
            };
            Messages.SendNotificationSuccess.className = 'Vendd.CustomForms.Messages.SendNotificationSuccess';


            Messages.SendNotificationFailure = function (response) {
              
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.CustomForms.Messages.SendNotificationFailure', response);
            };
            Messages.SendNotificationFailure.className = 'Vendd.CustomForms.Messages.SendNotificationFailure';


            Messages.Submit = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.CustomForms.Messages.Submit', data);
            };
            Messages.Submit.className = 'Vendd.CustomForms.Messages.Submit';


            Messages.SubmitSuccess = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.CustomForms.Messages.SubmitSuccess', response);
            };
            Messages.SubmitSuccess.className = 'Vendd.CustomForms.Messages.SubmitSuccess';


            Messages.SubmitFailure = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.CustomForms.Messages.SubmitFailure', response);
            };
            Messages.SubmitFailure.className = 'Vendd.CustomForms.Messages.SubmitFailure';

        return Messages;

        })(CustomForms.Messages || {});

        return CustomForms;

    })(Vendd.CustomForms || {});

return Vendd;

})(Vendd || {});